import ImageKit from 'imagekit-javascript'
import { ImageKitURLEndpoint } from './index'
import { pathFromAWSUrl } from './aws_path'

const imagekit = new ImageKit({
  urlEndpoint: ImageKitURLEndpoint
})

export function urlFromAWSUrl(awsUrl, transformation) {
  let path = pathFromAWSUrl(awsUrl)
  if (!path) {
    return ''
  }

  return imagekit.url({
    path,
    transformation
  })
}